enum UnidadesMedida {
    Volume = 0,
    Unidade = 1,
    Massa = 2,
    UI = 3,
    UFC = 4,
    UTR = 5
}

export default UnidadesMedida;